<template>
  <header class="w-full px-4 pb-5 pt-5 md:pt-10">
    <div class="flex w-full max-w-6xl my-0 mx-auto pr-5 justify-center items-center">
      <img
        src="@/assets/images/img_tm_lockup_red.png"
        width="152"
        height="32"
        alt="Logo"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
};
</script>
